<template>
  <div class="input">
    <input v-if="validationMethod === 'onBlur'" :id="inputId" @keypress="isNumberKey($event)" 
    :class="{error : validationError, upper : upperCase, shift : frontIcon}" @blur="getInput 
    ($event.target.value)" :type="type" v-model="inputValue" :readonly="readonly" 
    :disabled="disabled" @input="isThousandSeparator ? thousandSeparator($event) : ''" required>

    <input v-else-if="validationMethod === 'onChange'" :id="inputId" @keypress="isNumberKey($event)" 
    :class="{error : validationError, upper : upperCase, shift : frontIcon}" 
    @blur="getInput($event.target.value)" :type="type" v-model="inputValue" :readonly="readonly" 
    :disabled="disabled" @input="isThousandSeparator ? thousandSeparator($event) : ''" required>

    <i class="frontIcon" v-if="frontIcon" :class="frontIcon"></i>
    <i :class="[icon, tooltip ? 'backIcon2' : 'backIcon']" v-if="icon"></i>
    <adx-tooltip v-if="tooltip" :text="tooltip" position="top" class="tooltip">
      <span slot="content">
        <div class="image">
          <img src="/img/icons/ic-info-color-@3x 2.png" alt="">
        </div>
      </span>
    </adx-tooltip>
    <button v-if="button" class="btn-small small-font secondary" @click.stop="buttonClicked" >{{button}}</button>
    <label :class="['subhead', frontIcon ? 'shift': '']">{{label}}</label>
    <p v-if="validationError" class="msg-error small-font">{{message}}</p>
  </div>
</template>

<script>
import * as validationLib from '@/lib/validation/'
import Tooltip from '@/components/Tooltip'
const {
  helpers,
  validate
} = validationLib

export default {
  name: 'adx-form-input',
  components: {
    'adx-tooltip': Tooltip
  },
  props: {
    label: {
      required: false
    },
    value: {
      required: false
    },
    error: {
      required: false
    },
    icon: {
      required: false
    },
    frontIcon: {
      required: false
    },
    button: {
      required: false
    },
    type: {
      required: false
    },
    validation: {
      required: false
    },
    validationMethod: {
      required: false,
      default: `onBlur`
    },
    disabled: {
      required: false,
      default: false
    },
    isInitial: {
      required: false
    },
    readonly: {
      required: false
    },
    inputId: {
      required: false,
      default: ''
    },
    upperCase: {
      required: false,
      default: false
    },
    tooltip: {
      required: false
    },
    isNumberOnly: {
      required: false,
      default: false
    },
    isThousandSeparator: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      initial: true,
      inputValue: undefined,
      valid: undefined,
      message: undefined
    }
  },
  mounted() {
    if(this.value !== null || this.value !== undefined){
      if (!this.isThousandSeparator) {
        this.$data.inputValue = this.value
      } else {
        const result = this.value.toString().replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        this.$data.inputValue = result
      }
    }
    if (!this.validation) {
      this.$emit(`update:isInitial`, false)
    }
  },
  methods: {
    thousandSeparator(event) {
      const result = event.target.value.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      this.inputValue = result
    },
    isNumberKey($evt)
    {
      if ($evt) {
        var charCode = $evt.keyCode
        if (this.isNumberOnly && charCode > 31 && (charCode < 48 || charCode > 57)) {
          $evt.preventDefault();
        }
      }
      return true;
    },
    getInput(value) {
      this.validateInput(value)
    },
    buttonClicked() {
      this.$emit(`buttonClicked`)
    },
    validateInput(value) {
      if (this.validation) {
        const { valid, message } = validate(this.validation, value, this.label)
        if(valid) {
          this.$emit(`update:value`, value)
          this.$emit(`update:error`, false)
        } else {
          // this.$emit(`update:value`, ``)
          this.$emit(`update:error`, !valid)
        }
        this.valid = valid
        this.message = message
      } else {
        this.$emit(`update:value`, value)
        this.$emit(`update:error`, false)
      }
      this.$emit(`updatedValue`, value)
      this.$emit(`update:isInitial`, false)
    }
  },
  watch: {
    inputValue: helpers.debounce(function() {
      if(this.validationMethod === `onChange`) {
        if (!this.initial) {
          this.validateInput(this.inputValue)
        } else {
          this.initial = false
        }
      }
    }, 500),
    value: function () {
      this.inputValue = this.value
    },
    error: function () {
      if (typeof(this.error) == 'string') {
        this.message = this.error
      }
    }
  },
  computed: {
    validationError: function () {
      if (this.error) return this.error
      return this.valid === undefined ? false : !this.valid
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';

</style>